import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import users from '../../../../users';

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from 'luxon';

export default {
  name: 'captureFieldWork',
  mixins: [users, validationMixin],
  components: {
    TimePickerComp: require('../../../../customcontrols/timePicker.vue').default,
    datetime: Datetime,
    DateTime,
    DteTme: require('@/customcontrols/dateTimePicker.vue').default,
    CameraComp: require('@/components/uploadPictureToActivityAttachment/uploadPictureToActivityAttachment.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      timeOffset: 1,
      maxDate: '',
      minStartDate: '',
      freeInputSupervisor: false,
      appId: -1,
      lang: '',
      appData: {
        hasDateLimits: false,
        minStartDate: null,
        maxStartDate: null,
        completionDateChecked: false,
        minCompletionDate: null,
        maxCompletionDate: null,
        supervisor: '',
        comment: '',
        startDate: null,
        startTime: null,
        completionDate: null,
        completionTime: null
      },
      readOnly: false,
      supervisor: null,
      supervisors: [],
      //fieldWork: {
      //  supervisor: '',
      //  comment: '',
      //  startDate: null,
      //  startTime: null,
      //  completionDateChecked: false,
      //  completionDate: null,
      //  completionTime: null,
      //  hasDateLimits: false,
      //  minStartDate: null,
      //  maxStartDate: null,
      //  minCompletionDate: null,
      //  maxCompletionDate: null
      //},
      startDate2: null,
      startTime2: null,
      completionDate2: null,
      completionTime2: null,
      minStartDate2: null,
      maxStartDate2: null,
      minCompletionDate2: null,
      maxCompletionDate2: null
    };
  },
  validations: {
    dataObj: {
      appData: {
        supervisor: {
          required,
          minLength: 3
        }
      }
    }
  },
  computed: {},
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('capture_field_work_updated', this.init);
    this.init();
  },
  watch: {
    'appData.completionDateChecked': function (val) {
      if (!val) {
        this.dataObj.appData.completionDate = '';
        this.dataObj.appData.completionTime = '';
      }
    }
  },
  methods: {
    freeInputButtonPressed() {
      if (this.freeInputSupervisor && this.dataObj.appData.supervisor != null) this.dataObj.appData.supervisor = this.dataObj.appData.supervisor.text;
      else this.dataObj.appData.supervisor = '';
    },
    checkDates() {
      let startDate = moment(this.dataObj.appData.startDate);
      let endDate = moment(this.dataObj.appData.completionDate);

      if (startDate.isAfter(endDate)) {
        this.$alertMsg(this.$t('activities.startEndDateError'), 3);
        this.dataObj.appData.completionDate = '';
      }
    },
    init() {
      Vue.nextTick(() => {
        this.minStartDate = moment(this.dataObj.appData.minStartDate).format();
        this.maxDate = moment(this.dataObj.appData.maxDate).format();

        if (this.dataObj.supervisor == '' || this.dataObj.supervisor == null) {
          this.freeInputSupervisor = false;
        } else {
          if (this.dataObj.supervisors != null && this.dataObj.supervisors.length > 0 && /^\d+$/.test(this.dataObj.appData.supervisor)) {
            this.freeInputSupervisor = false;
            this.dataObj.appData.supervisor = this.dataObj.supervisors.filter((s) => s.value == parseInt(this.dataObj.appData.supervisor))[0];
          } else {
            this.freeInputSupervisor = true;
          }
        }

        //dates check / processing
        if (!this.dataObj.appData.startDate || moment(this.dataObj.appData.startDate).year() < 1900) {
          this.dataObj.appData.startDate = moment().format();
          this.dataObj.appData.startTime = this.dataObj.appData.startDate;
        }

        if (!this.dataObj.appData.completionDate || moment(this.dataObj.appData.completionDate).year() < 1900) {
          this.dataObj.appData.completionDate = moment().add(this.timeOffset, 'hours').format();
          this.dataObj.appData.completionTime = this.dataObj.appData.completionDate;
        }

        this.appData.completionDateChecked = this.dataObj.appData.completionDate != null && this.dataObj.appData.completionDate != '';

        let now = moment();

        let startTime = moment(this.dataObj.appData.startTime);
        let startDateTime = moment(this.dataObj.appData.startDate).set({ hour: startTime.hours(), minutes: startTime.minute() });

        let completionTime = moment(this.dataObj.appData.completionTime);
        let completionDateTime = moment(this.dataObj.appData.completionDate).set({ hour: completionTime.hours(), minute: completionTime.minute() });

        this.dataObj.appData.startDate = startDateTime.format();

        if (this.appData.completionDateChecked) {
          if (startDateTime.isAfter(completionDateTime)) this.dataObj.appData.completionDate = startDateTime.add(this.timeOffset, 'hours').format();
          else this.dataObj.appData.completionDate = completionDateTime.format();
        }

        this.appId = this.dataObj.appId;
        this.readOnly = this.dataObj.readOnly;
        this.appData = this.dataObj.appData;

        this.supervisors = this.appData.supervisors;
        this.startDate2 = moment(this.appData.startDate).format('DD/MM/YYYY');
        this.startTime2 = moment(this.appData.startTime).format('HH:mm:ss');
        this.completionDate2 = this.appData.completionDate == null ? null : moment(this.appData.completionDate).format('DD/MM/YYYY');
        this.completionTime2 = moment(this.appData.completionTime).format('HH:mm:ss');
        this.minStartDate2 = moment(this.appData.minStartDate).format('DD/MM/YYYY');
        this.maxStartDate2 = moment(this.appData.maxStartDate).format('DD/MM/YYYY');
        this.minCompletionDate2 = moment(this.appData.minCompletionDate).format('DD/MM/YYYY');
        this.maxCompletionDate2 = moment(this.appData.maxCompletionDate).format('DD/MM/YYYY');
      });
    },
    getValidationClass(objName, fieldName) {
      const field = this.$v[objName][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        };
      }
    },
    onTimeChanged(val) {
      this[val.var] = val.time;
    },
    validateAppData() {
      //check dates
      if (!this.dataObj.appData.startDate || this.dataObj.appData.startDate == 'Invalid date') {
        this.$alertMsg(this.$t('activities.DateError'));
        return false;
      }

      if (this.appData.completionDateChecked) {
        if (
          moment(this.dataObj.appData.startDate).isAfter(this.dataObj.appData.completionDate) ||
          this.dataObj.appData.completionDate == 'Invalid date'
        ) {
          this.$alertMsg(this.$t('activities.startEndDateError'));
          return false;
        }
      }

      if (this.dataObj.appData.completionDate == 'Invalid date' || this.dataObj.appData.completionTime == 'Invalid date') {
        this.dataObj.appData.completionDate = '';
        this.dataObj.appData.completionTime = '';
        //this.$alertMsg(this.$t('activities.DateError'));
        //return false;
      }

      if (!this.dataObj.appData.supervisor || this.dataObj.appData.supervisor.value < 0) {
        this.$alertMsg(this.$t('validation.requiredSupervisor'));
        return false;
      }

      return true;
    }
  }
};
